export function getWorkoutPresentationClasses({ readOnly, allSetsComplete, isVolumeRecord }) {
  return [
    readOnly ? 'read-only' : '',
    allSetsComplete ? 'all-complete' : '',
    isVolumeRecord ? 'volume-record' : ''
  ].filter(Boolean).join(' ');
}
